"use client";

import { motion } from "framer-motion";

export function WhatWeOffer() {
    return (
        <section className="bg-white py-14 md:py-18 hidden">
            <div className="max-w-[1440px] mx-auto px-4 md:px-8 lg:px-12">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <h2 className="text-[#1A1A1A] text-2xl md:text-3xl font-bold mb-5">
                        What we offer?
                    </h2>
                    <p className="text-[#666666] text-sm md:text-base leading-relaxed mb-4">
                        Whether you need to staff at a single facility or support a multi-location operation with uniquely skilled people – We have technical staffing services to help you meet your goals.
                    </p>
                    <p className="text-[#666666] text-sm md:text-base leading-relaxed">
                        Our specialized recruiters understand the unique skills and requirements of the Information Technology market. They have large pool of their own resource and also broad connection throughout the industry and can quickly locate the best talent in the field.
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
